module.exports = __webpack_public_path__ + "static/media/Hero_Crop_Mob.263b10a8.png";